
{
  "fr": {
    "CustomerProjectCard": {
      "buttons": {
        "edit": "Modifier",
        "delete": "Supprimer",
        "addToCart": "Ajouter au panier"
      },
      "unitPrice": "soit {value} TTC / unité",
      "price": "{value} TTC",
      "priceWithoutVAT": "{value} HT",
      "confirmDeletion": "Êtes-vous sûr de vouloir supprimer ce projet ? Cette opération est définitive.",
      "addToCart": {
        "success": "Votre projet a bien été ajouté au {linkStart}panier{linkEnd}."
      },
      "outdated": "Le thème de votre projet a évolué. Pensez à le modifier avant de l'ajouter au panier.",
      "clickHere": "Cliquer ici"
    }
  }
}
